<template>
  <span
    v-show="status.text"
    :class="statusClassName"
    v-text="status.text"
  />
</template>

<script>
export default {
  name: 'Status',
  props: {
    status: {
      type: Object,
      default: () => ({
        id: 0,
        text: '未知状态',
      }),
    },
  },
  computed: {
    statusClassName() {
      let c = 'status-box ';
      const { id } = this.status;

      switch (id) {
        case 0:
          c += 'ing';
          break;
        case 1:
          c += 'fail';
          break;
        case -1:
        case 2:
          c += 'succ';
          break;
        default:
          break;
      }

      return c;
    },
  },
};
</script>

<style lang="less" scoped>
.status-box {
  display: inline-block;
  border-radius: 4px 0px 6px 0px;
  color: #fff;
  padding: 4px 18px;
  font-size: 12px;
  font-weight: bold;
  text-align: center;

  &.def {
    background: rgba(0, 0, 0, 0.3);
    display: none;
  }

  &.ing {
    background: rgba(246, 180, 35, 1);
  }

  &.fail {
    background: rgba(255, 97, 97, 1);
  }

  &.succ {
    background: rgba(76, 211, 75, 1);
  }
}
</style>
